import { AbstractControl } from '@angular/forms';
import { DateTime } from 'luxon';

/**
 * Cross-field validator for hotel stay ranges (TIC-6913).
 *
 * Attach to the check-out date control: invalid when the check-out date is
 * earlier than the sibling `checkInDate` value. Equal dates (same-day
 * checkout) are valid. Empty values are left to the `required` validator.
 */
export function checkoutAfterCheckInValidator(control: AbstractControl) {
  const checkInValue = control.parent?.get('checkInDate')?.value as string | null | undefined;

  if (!checkInValue || !control.value) {
    return null;
  }

  const checkIn = DateTime.fromISO(checkInValue);
  const checkout = DateTime.fromISO(control.value as string);

  return checkout >= checkIn ? null : { checkoutBeforeCheckIn: true };
}
